import { render, staticRenderFns } from "./NullObservaciones.vue?vue&type=template&id=4ebae235&"
import script from "./NullObservaciones.vue?vue&type=script&lang=js&"
export * from "./NullObservaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports